import { render, staticRenderFns } from "./MainWindow.vue?vue&type=template&id=72ea4d7c&scoped=true"
import script from "./MainWindow.vue?vue&type=script&lang=js"
export * from "./MainWindow.vue?vue&type=script&lang=js"
import style0 from "./MainWindow.vue?vue&type=style&index=0&id=72ea4d7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ea4d7c",
  null
  
)

export default component.exports